import React, { PropsWithChildren } from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export function PageLeadPageTypeDefinition({ children }: PropsWithChildren) {
  const { t } = useSonTranslation('MetaInfo');

  return (
    <p className="invisible">
      <dfn>{t('documentType')}: </dfn>
      {children}
    </p>
  );
}
